import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { Page1 } from "@/pages";
import React from "react";
import { permissionsDeveloper } from "@/utils";

export const qadeerRoutes: React.ReactElement[] = [
  <Route
    key="page1"
    path="page1"
    element={
      <ProtectedRoute element={<Page1 />} codes={permissionsDeveloper} />
    }
  />,
];
